import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { programasArray } from '../../json/programasItem';
import './Programas.css';

class Programas extends Component {
  isExternal = (url = '') => /^https?:\/\//i.test(url);
  isPdf = (url = '') => /\.pdf(\?.*)?$/i.test(url) || url.startsWith('/pdf/');

  renderAnchorOrLink = (url, label) => {
    const openNewTab = this.isExternal(url) || this.isPdf(url);

    // Para EXTERNOS y PDFs => <a> (evita que React Router intercepte)
    if (openNewTab) {
      return (
        <a href={url} target="_blank" rel="noopener noreferrer">
          {label}
        </a>
      );
    }

    // Para rutas internas del SPA => <Link>
    return <Link to={url}>{label}</Link>;
  };

  render() {
    return (
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="programas-title">
              <br /><br />
              <h1>Programas</h1>
              <hr className="hr-gob" />
            </div>
          </div>
        </div>

        <div className="row">
          {programasArray.map((item, index) => (
            <div key={index} className="col-md-3 col-sm-6 col-12">
              <div className="card_container_programas">
                <div className="card_nombre">
                  <h5>{item.programa}</h5>

                  {(item.links || []).map((l, i) => (
                    <p key={i}>
                      <span className="badge bg-secondary">
                        {this.renderAnchorOrLink(l.url, l.label)}
                      </span>
                    </p>
                  ))}
                </div>
              </div>
            </div>
          ))}

        </div>

        <br />
      </div>
    );
  }
}

export default Programas;
